<mat-card flex="100">
  <mat-card-title class="float-left">Duty History</mat-card-title>
  <mat-divider></mat-divider>
  <div>
    <mat-card-actions position="end">
      <a routerLink="/duty-logs/retro" mat-button>Log Previous</a>
    </mat-card-actions>
  </div>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div
      fxLayout="row wrap"
      fxLayoutGap="10px"
      fxLayoutAlign="start start"
      [formGroup]="reportParameters"
    >
      <mat-form-field>
        <mat-select placeholder="Search By" formControlName="dutyEvent">
          <mat-option value="DutyOn">Duty On</mat-option>
          <mat-option value="DutyOff">Duty Off</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          formControlName="startTime"
          [matDatepicker]="startPicker"
          placeholder="Start date"
        />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <input
          matInput
          formControlName="endTime"
          [matDatepicker]="endPicker"
          placeholder="End date"
        />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <ng-container *ngIf="isAviationSupervisor">
        <fl-employee-autocomplete
          formControlName="employeeId"
          [includeDispatched]="includeDispatched"
        ></fl-employee-autocomplete>
        <mat-checkbox type="checkbox" [formControl]="displayMyDutyLogsCtrl">
          My history only?
        </mat-checkbox>
        <mat-checkbox type="checkbox" [formControl]="displayDispatchedDutyLogsCtrl">
          Include Dispatched by {{ companyCode }}?
        </mat-checkbox>
      </ng-container>
      <a mat-button routerLink="/duty-logs" (click)="onClick($event)">Clear filters</a>
    </div>
    <mat-paginator
      [pageSize]="pageSize$ | async"
      [pageIndex]="pageIndex$ | async"
      [pageSizeOptions]="pageSizes"
      [length]="total$ | async"
      (page)="onPage($event)"
    >
    </mat-paginator>
    <ng-template
      [flLoading]="loadingKey"
      [flLoadingUntil]="dutyLogEntries$ | async"
      flLoadingStrategy="overlay"
      flLoadingColor="primary"
    >
      <table mat-table [dataSource]="dutyLogEntries$">
        <ng-container matColumnDef="dutyStartTime">
          <th mat-header-cell *matHeaderCellDef>Duty On</th>
          <td mat-cell *matCellDef="let dutyLog">
            <span
              *ngIf="getFromStore(dutyLog) | async as dl"
              title="{{ dl.dutyPeriodStarTime | date : 'full' || 'Unknown' }}"
            >
              {{ (dl.dutyPeriodStartTime | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="dutyEndTime">
          <th mat-header-cell *matHeaderCellDef>Duty Off</th>
          <td mat-cell *matCellDef="let dutyLog">
            <span
              *ngIf="getFromStore(dutyLog) | async as dl"
              title="{{ dl.dutyPeriodEndTime | date : 'full' || 'Unknown' }}"
            >
              {{ (dl.dutyPeriodEndTime | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="employee">
          <th mat-header-cell *matHeaderCellDef>Employee</th>
          <td mat-cell *matCellDef="let dutyLog">
            <ng-container *ngIf="getFromStore(dutyLog) | async as dl">
              {{ dl.employeeFirstName }} {{ dl.employeeLastName }}
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let dutyLog">
            <ng-container *ngIf="getFromStore(dutyLog) | async as dl">
              <a
                mat-mini-fab
                color="primary"
                routerLink="{{ dl.id }}"
                *ngIf="showEditShift(dl) | async"
              >
                <mat-icon class="mat-24">edit</mat-icon> </a
              >&nbsp;
              <a mat-mini-fab color="primary" (click)="delete(dl)" *ngIf="canDeleteHistory(dl)">
                <mat-icon class="mat-24">delete</mat-icon>
              </a>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSize]="pageSize$ | async"
        [pageIndex]="pageIndex$ | async"
        [pageSizeOptions]="pageSizes"
        [length]="total$ | async"
        (page)="onPage($event)"
      >
      </mat-paginator>
    </ng-template>
  </mat-card-content>
</mat-card>
